import * as React from "react";
import {AppTranslations} from "../../../../components/Utils/translations/AppTranslations";
import {DEFAULT_TEMPERATURE_UNIT, UnitOfMeasure} from "../HaccpController";

import "./HaccpLegend.scss";

declare var AppTranslations: AppTranslations;

export const unitMapper = Object.freeze({
    [UnitOfMeasure.CELSIUS]: "°C",
    [UnitOfMeasure.FAHRENHEIT]: "°F",
    [UnitOfMeasure.KELVIN]: "K",
});

const unitDeltaMapper = Object.freeze({
    [UnitOfMeasure.CELSIUS]: 1,
    [UnitOfMeasure.FAHRENHEIT]: 1.8,
    [UnitOfMeasure.KELVIN]: 1,
});

export interface HaccpLegendProps {
    hotterDeviations: string[];
    colderDeviations: string[];
    inRange: string;
    cleaning: string;
    defrost: string;
    off: string;
    noData: string;
    texts: {
        legend: string,
        temperature: string,
        deviation: string,
        defrost: string,
        noData: string,
        off: string,
        high: string,
        low: string,
        edit: string,
    };
}

export class HaccpLegend extends React.Component<HaccpLegendProps, any> {

    private static drawSquare = (color: string, text?: string, textColor?: string, style?: any) => {
        return (
            <div
                className={"legend-square"}
                style={{
                    backgroundColor: color,
                    ...style,
                }}
            >
                {text ? <p>{text}</p> : null}
            </div>
        );
    }

    constructor(props) {
        super(props);
    }

    public render() {
        return (
            <div className={"HaccpLegend"}>
                <div className={"legend-body"}>
                    <div className={"section"}>
                        <h2 className={"section-title"} style={{textAlign: "left"}}>{this.props.texts.deviation}</h2>
                        <div className={"steps"}>
                            {this.props.colderDeviations.map((color, index) => {
                                return (
                                    <>
                                        <div className={"deviations-square"} key={index}>
                                            {HaccpLegend.drawSquare(
                                                color,
                                                ((index - this.props.colderDeviations.length)
                                                    * unitDeltaMapper[DEFAULT_TEMPERATURE_UNIT])
                                                    .toFixed(1) + "°",
                                                (index - this.props.colderDeviations.length) < -1 ? "white" : "black",
                                            )}
                                        </div>
                                    </>
                                );
                            })}
                            {this.tallLine(
                                this.props.texts.low,
                                {transform: "translate(-99.5%, -110%)", right: -5},
                                true,
                            )}
                            {HaccpLegend.drawSquare(this.props.inRange, unitMapper[DEFAULT_TEMPERATURE_UNIT], "black", { color: "black", width: 70 })}
                            {this.tallLine(this.props.texts.high, {left: -4.5})}
                            {this.props.hotterDeviations.map((color, index) => {
                                return (
                                    <>
                                        <div className={"deviations-square"} key={index}>
                                            {
                                                HaccpLegend.drawSquare(
                                                    color,
                                                    "+" + ((index + 1)
                                                    * unitDeltaMapper[DEFAULT_TEMPERATURE_UNIT])
                                                        .toFixed(1) + "°",
                                                    index > 0 ? "white" : "black",
                                                )
                                            }
                                        </div>
                                    </>
                                );
                            })}
                        </div>
                    </div>
                    <div className={"section"}>
                        <h2 className={"section-title"}>{this.props.texts.defrost}</h2>
                        <div className={"steps"}>
                            {HaccpLegend.drawSquare(this.props.defrost)}
                        </div>
                    </div>
                    <div className={"section"}>
                        <h2 className={"section-title"}>{this.props.texts.off}</h2>
                        <div className={"steps"}>
                            {HaccpLegend.drawSquare(this.props.off, "-", "white")}
                        </div>
                    </div>
                    <div className="section">
                        <h2 className="section-title">
                            {AppTranslations.haccpPageTranslation.legendEditLabel}
                        </h2>
                        <div className="steps">
                            <div
                                className="legend-square"
                                style={{
                                    backgroundColor: "rgb(255, 255, 255)",
                                }}
                            >
                                <div
                                    style={{
                                        backgroundColor: "rgb(255, 237, 0)",
                                        width: "100%",
                                        height: "4px",
                                        alignSelf: "flex-end",
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={"section"}>
                        <h2 className={"section-title"}>{this.props.texts.noData}</h2>
                        <div className={"steps"}>
                            {HaccpLegend.drawSquare(this.props.noData, "-", "black")}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private tallLine = (text?: string, style?: any, left?: boolean) => {
        return (
            <div
                style={{
                    height: "25px",
                    width: 1,
                    display: "inline-flex",
                    alignItems: "flex-end",
                }}
            >
                <div
                    className={"lo-hi-labels"}
                    style={{...style}}
                >
                    <p className={"lo-hi-text"}>{text}</p>
                    <div className={"triangle-down"} style={left ? {right: 0} : {}}/>
                </div>
            </div>
        );
    }
}
